import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Toast } from '@shared/types/toast'

const DEFAULT_TOAST_DURATION_MS = 4000

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([])

  function addToast(toast: Omit<Toast, 'id'>) {
    const id = crypto.randomUUID()

    const newToast: Toast = {
      id,
      duration: DEFAULT_TOAST_DURATION_MS,
      ...toast,
    }

    toasts.value.push(newToast)

    if (newToast.duration) {
      setTimeout(() => removeToast(id), newToast.duration)
    }
  }

  function removeToast(id: string) {
    toasts.value = toasts.value.filter((toast) => toast.id !== id)
  }

  return {
    toasts,
    addToast,
    removeToast,
  }
})
